<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} </div>
        <div class="modal-body">
            <div class="button-vitale-wrapper">
                <div class="carte-vitale" type="button" (mousedown)="lectureCarteVitale()"></div>
            </div>
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit(true)" *ngIf="formGroup">
                <frg-form-input label="Nom de naissance" id="nomNaissance" type="text" placeholder="Ex: Dupont"
                    [formGroup]="formGroup" [control]="formGroup.get('nomNaissance')" class="patient-form-input"
                    [errorMessage]="errorMessage" required="true">
                </frg-form-input>
                <frg-form-input label="Prénom(s)" id="prenom" type="text" placeholder="Ex: Jean" [formGroup]="formGroup"
                    [control]="formGroup.get('prenom')" class="patient-form-input" [errorMessage]="errorMessage"
                    required="true">
                </frg-form-input>
                <frg-form-input label="Date de naissance" id="dateNaissance" type="date" placeholder="JJ/MM/AAAA"
                    [formGroup]="formGroup" [control]="formGroup.get('dateNaissance')" class="patient-form-input"
                    [errorMessage]="errorMessage" required="true" [minDate]="minDate" [maxDate]="maxDate">
                </frg-form-input>
                <frg-form-input label="Sexe" id="sexe" type="ngSelect" [formGroup]="formGroup"
                    [control]="formGroup.get('sexe')" class="patient-form-input" [selectValue]="sexes"
                    required="true" isParentModal="true">
                </frg-form-input>
                <frg-form-input label="Lieu de naissance" id="lieuNaissance" type="text" [formGroup]="formGroup"
                    [control]="formGroup.get('lieuNaissance')" class="patient-form-input">
                </frg-form-input>
                <div class="button-wrapper">
                    <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'">
                        Rechercher</frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
            <div class="table">
                <frg-table id="search-insi-result-table" *ngIf="!(notFoundError && notFoundError !== '')" [keysBody]="dataBodyTable" [keysColumn]="dataColumnTable" [isRowsClickable]="true"
                    (onClickRow)="selectedValue($event)" class="reduce"></frg-table>

                <div class="msg-details-wrapper" *ngIf="notFoundError && notFoundError !== ''">
                    <div class="search-error-message" [ngStyle]="{'width': tableWidth + 'px'}">Une erreur est survenue</div>

                    <div class="button" (click)="showDetails = !showDetails">
                        <div class="icon" [ngClass]="{ 'active': showDetails }"></div>
                        <p>Afficher plus de détails</p>
                    </div>
                    <div class="msg" *ngIf="showDetails">{{ notFoundError }}</div>
                </div>

                <div class="msg-details-wrapper" *ngIf="noPatientFoundMsg && noPatientFoundMsg !== ''">
                    <div class="msg no-patient-found">{{ noPatientFoundMsg }}</div>
                </div>

                <div class="button-table-wrapper">
                    <frg-button (activated)="closeInsiModal()" [backgroundColor]="'var(--darkest-primary)'">Annuler
                    </frg-button>
                    <frg-button [disabled]="isSubmitDisabled" [type]="'button'" [backgroundColor]="'var(--primary)'"
                        (activated)="submitIdentity()">
                        Sélectionner</frg-button>
                </div>
            </div>
        </div>

        <div class="loading-background" *ngIf="isLoading"></div>
    </div>
</div>
<div class="modal-background"></div>